import gql from 'graphql-tag'

export const communityListData = gql`
  {
    getCommunityList {
      items {
        name
        community_id
        parent_id
        community_code
        community_address
        community_name
      }
    }
  }
`

export const residentsListData = gql`
  query getResidentsList (
    $communityId: Int!
  ) {
      getResidentList (
        community_id: $communityId
      ) {
        residents {
          email
          name
          survey_date
        }
    }
  }
`

export const reportTypesData = gql`
  {
    getReportTypes {
      types {
        code
        name
        id
      }
    }
  }
`

export const getReport = gql`
  query report (
    $code: String!
    $communityId: Int!
    $type: Int!
    $dateRange: [String!]!
    $json: Boolean
    $email: String
    $name: String
    $templateCode: String
  ) {
    report(
      code: $code,
      community_id: $communityId,
      type: $type,
      date_range: $dateRange,
      json: $json,
      email: $email,
      name: $name,
      template_code: $templateCode
    ) {
      url
      json
    }
  }
`

export const getQuestions = gql`
  query chartQuestions (
    $code: String!
  ) {
    chartQuestions (
      code: $code
    ) {
      questions {
        id
        title
      }
    }
  }
`

export const getChartReport = gql`
  query chartReport (
    $code: String!
    $question_id: Int!
    $community_id: Int
    $email: String
    $name: String
    $template_code: String
    $date_range: String
    $json: Boolean
  ) {
    chartReport (
      code: $code
      question_id: $question_id
      community_id: $community_id
      email: $email
      name: $name
      template_code: $template_code
      date_range: $date_range
      json: $json
    ) {
      url
      title
      answered_by
      display_type
      json
      question_options {
        option_id
        option_label
        selected_by
        recommendation
        parent_id
        parent_label
      }
    }
  }
`
